export function postsSliderSol3() {
    const sliderSol3 = $(".posts-slider-sol3");
    const buttonsSol3 = sliderSol3.parents("section").find(".slider-controls button");
    

    $(window).on("resize load", function () {
        let flag = (window.innerWidth < 768 && sliderSol3.find(".post-item").length < 2) ||
            (window.innerWidth >= 768 && window.innerWidth < 1024 && sliderSol3.find(".post-item").length < 3) ||
            (window.innerWidth >= 1024 && sliderSol3.find(".post-item").length < 4);

        showButtonsSol3(flag);
    });

    sliderSol3.slick({
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        variableWidth: true,
        
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });


    buttonsSol3.click(function () {
        const direction = $(this).attr("class");

        switch (direction) {
            case "prev":
                sliderSol3.slick("slickPrev");
                break;
            case "next":
                sliderSol3.slick("slickNext");
                break;
        }
    });

    function showButtonsSol3(flag) {
        if (flag) {
            buttonsSol3.css("visibility", "hidden");

        } else {
            buttonsSol3.css("visibility", "visible");
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/posts-slider-sol3.js